module.exports = __webpack_public_path__ + "static/missionBanner1-d086b8ce9d386a4702835b7ab27bc086.jpeg";